// extracted by mini-css-extract-plugin
export default {"metric-table":"MetricTable_metric-table__bNp3r"};